module.exports = __webpack_public_path__ + "0a45f8f38527964b31d436395b0e4868.svg";